"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormValidation = void 0;
var util_1 = require("../common/util");
var common_1 = require("../model/common");
var custom_validation_1 = require("./custom_validation");
var custom_validation_service_1 = require("./custom_validation.service");
var encrypt_deccrypt_1 = require("./encrypt_deccrypt");
var validation_1 = require("./validation");
var FormValidation = (function () {
    function FormValidation(config) {
        this.config = config;
        this.encryptAndDecrypt = new encrypt_deccrypt_1.EncryptAndDecrypt(this.config);
        this.formCustomValidation = new custom_validation_1.FormCustomValidation();
        this.$form = {};
        this.rules = {};
        this.allFormRules = {};
    }
    FormValidation.prototype.init = function (formELement, data) {
        var _this = this;
        var elements = formELement.querySelectorAll('[rsMonitor]');
        var formkey = formELement.getAttribute('rsActionOriginator');
        this.serviceCallResponseData = data;
        this.createRules(elements, formkey);
        console.log(this.rules);
        this.$form[formkey] = formELement;
        var rsValidatorEventType = formELement.querySelectorAll('[rsValidatorEventType]');
        var eventType = [];
        rsValidatorEventType.forEach(function (element) {
            var type = element.getAttribute('rsValidatorEventType');
            if (type) {
                eventType.push(type);
            }
        });
        var uniqEventType = eventType.filter(function (item, pos) {
            return eventType.indexOf(item) == pos;
        });
        uniqEventType.forEach(function (type) {
            _this.setterEventListener(formELement, type, formkey);
        });
    };
    FormValidation.prototype.setterEventListener = function (formELement, type, formkey) {
        var _this = this;
        formELement.addEventListener(type, function (event) {
            if (event && event.target && type === event.target.getAttribute('rsValidatorEventType')) {
                var isSubmit = event.target.getAttribute('rsSubmit');
                if (!isSubmit || isSubmit === 'false' || isSubmit === 'undefined' || isSubmit.length === 0) {
                    isSubmit = false;
                }
                else {
                    isSubmit = true;
                }
                if (event.target.getAttribute('rsMonitor') && !isSubmit) {
                    var elem = event.target;
                    _this.rulesForElement(elem);
                    var rulesElement = _this.rulesForElement(elem);
                    _this.updateRules(event.target.getAttribute('rsMonitor'), formkey, rulesElement);
                    var errorData = _this.validateField(elem, formkey);
                    if (errorData && Object.keys(errorData).length > 0) {
                        var targetElementList = [];
                        targetElementList[event.target.getAttribute('rsMonitor')] = elem;
                        _this.setError(errorData, formkey, targetElementList);
                    }
                    else {
                        _this.clearErrorField(elem, formkey);
                    }
                }
            }
        });
    };
    FormValidation.prototype.rulesForElement = function (item) {
        var validatorRulesList = [];
        var rsRequired = this.covertToJson(item.getAttribute('rsRequired'));
        var rsPattern = this.covertToJson(item.getAttribute('rsPattern'));
        var rsMinLength = this.covertToJson(item.getAttribute('rsMinLength'));
        var rsMaxLength = this.covertToJson(item.getAttribute('rsMaxLength'));
        var rsInt = this.covertToJson(item.getAttribute('rsInt'));
        var rsCustomValidator = item.getAttribute('rsCustomValidator');
        if (rsRequired && (rsRequired.val === 'true' || rsRequired.val === true)) {
            var msg = this.getMessage(rsRequired.message, 'rsRequired', item);
            validatorRulesList.push(validation_1.isRequired(msg));
        }
        if (rsInt && (rsInt.val === 'true' || rsInt.val === true)) {
            var msg = this.getMessage(rsInt.message, 'rsInt', item);
            validatorRulesList.push(validation_1.isInt(msg));
        }
        if (rsPattern && rsPattern.val) {
            var msg = this.getMessage(rsPattern.message, 'rsPattern', item);
            validatorRulesList.push(validation_1.isPattern(rsPattern.val, msg));
        }
        if (rsMinLength && rsMinLength.val) {
            var msg = this.getMessage(rsMinLength.message, 'rsMinLength', item);
            validatorRulesList.push(validation_1.isMinLength(rsMinLength.val, msg));
        }
        if (rsMaxLength && rsMaxLength.val) {
            var msg = this.getMessage(rsMaxLength.message, 'rsMaxLength', item);
            validatorRulesList.push(validation_1.isMaxLength(rsMaxLength.val, msg));
        }
        if (rsCustomValidator && rsCustomValidator !== 'null' && rsCustomValidator !== 'undefined') {
            var lengthValue = rsCustomValidator.match(/\[.*\]/);
            var arg = null;
            var UpdatedVal = rsCustomValidator.trim();
            if (lengthValue) {
                arg = lengthValue.toString().slice(1, -1);
                try {
                    if (arg.indexOf("" + util_1.Constants.MODEL) > -1) {
                        arg = this.getDataFromModel(arg, this.serviceCallResponseData);
                    }
                    else {
                        if (arg && arg !== 'undefined') {
                            arg = arg.replace(/(\s*?{\s*?|\s*?,\s*?)(['"])?([a-zA-Z0-9]+)(['"])?:/g, '$1"$3":');
                            arg = arg.replace(/'/g, '"');
                            arg = JSON.parse(arg);
                        }
                        else if (arg === 'undefined') {
                            arg = undefined;
                        }
                    }
                }
                catch (error) {
                    throw Error(rsCustomValidator + ', Argument is not valid');
                }
                UpdatedVal = rsCustomValidator.replace(lengthValue[0], '');
            }
            validatorRulesList.push(validation_1.isCustomValidator(UpdatedVal, arg, item));
        }
        return validatorRulesList;
    };
    FormValidation.prototype.getDataFromModel = function (modelKey, model) {
        var q = modelKey.replace(util_1.Constants.MODEL + ".", '');
        var key = q.split('[').join('.').split(']').join('');
        var value = key.split('.').reduce(function (v, k) { return (v || {})[k]; }, model);
        return value;
    };
    FormValidation.prototype.updateRules = function (name, formkey, rules) {
        this.allFormRules[formkey][name] = rules;
    };
    FormValidation.prototype.createRules = function (elements, formkey) {
        this.allFormRules[formkey] = {};
        this.rules = {};
    };
    FormValidation.prototype.getMessage = function (message, type, el) {
        var element = el;
        var htmlTextInputTypes = [
            'date',
            'datetime-local',
            'email',
            'file',
            'month',
            'number',
            'password',
            'search',
            'tel',
            'text',
            'time',
            'url',
            'week',
            'textarea',
        ];
        if (message && message.length > 0) {
            return message;
        }
        else {
            if (type === 'rsRequired') {
                if (element.type === 'checkbox')
                    return common_1.DEFAULT_MESSSAGE.messageValueMissingCheckbox;
                if (htmlTextInputTypes.includes(element.type))
                    return common_1.DEFAULT_MESSSAGE.messageValueMissing;
                if (element.type === 'radio')
                    return common_1.DEFAULT_MESSSAGE.messageValueMissingRadio;
                if (element.tagName === 'SELECT')
                    return common_1.DEFAULT_MESSSAGE.messageValueMissingSelect;
            }
            if (type === 'rsInt') {
                return common_1.DEFAULT_MESSSAGE.messageBadInput;
            }
            if (type === 'rsPattern') {
                return common_1.DEFAULT_MESSSAGE.messagePatternMismatch;
            }
            if (type === 'rsMinLength') {
                if (element.type === 'checkbox' || element.tagName === 'SELECT') {
                    return common_1.DEFAULT_MESSSAGE.messageRangeUnderflow;
                }
                else {
                    return common_1.DEFAULT_MESSSAGE.messageTooShort;
                }
            }
            if (type === 'rsMaxLength') {
                if (element.type === 'checkbox' || element.tagName === 'SELECT') {
                    return common_1.DEFAULT_MESSSAGE.messageRangeOverflow;
                }
                else {
                    return common_1.DEFAULT_MESSSAGE.messageTooLong;
                }
            }
        }
    };
    FormValidation.prototype.covertToJson = function (jsonStr) {
        var regex = /(\w+):([^\s]+)/g;
        if (jsonStr && regex.test(jsonStr)) {
            try {
                console.log(jsonStr);
                jsonStr = jsonStr.replace(/(\s*?{\s*?|\s*?,\s*?)(['"])?([a-zA-Z0-9]+)(['"])?:/g, '$1"$3":');
                var modifyStr = jsonStr.replace(/'/g, '"');
                return JSON.parse(modifyStr);
            }
            catch (error) {
                throw Error('Attribute value not valid');
            }
        }
        else {
            var obj = {
                val: jsonStr,
            };
            return obj;
        }
    };
    FormValidation.prototype.validateField = function (elem, formkey) {
        var name = elem.getAttribute('rsMonitor');
        var rule = {};
        if (name) {
            rule[name] = this.allFormRules[formkey][name];
            var value = {};
            var elementVal = void 0;
            if (elem.tagName === 'SELECT') {
                var selectedOptions = [];
                if (elem) {
                    selectedOptions = Array.from(elem.options)
                        .filter(function (option) {
                        if (option.value) {
                            return option.selected;
                        }
                    })
                        .map(function (option) {
                        if (option.value) {
                            return option.value;
                        }
                    });
                }
                elementVal = selectedOptions;
            }
            else if (elem.type === 'checkbox' || elem.type === 'radio') {
                var el = elem.getAttribute('name');
                var radio = document.getElementsByName("" + el);
                var selectedValues = Array.from(radio)
                    .filter(function (option) {
                    return option.checked;
                })
                    .map(function (option) {
                    return option.value;
                });
                elementVal = selectedValues;
            }
            else {
                elementVal = elem.value;
            }
            value[name] = elementVal;
            var errorData = new validation_1.Validation(rule).validate(value);
            console.log('rule', rule);
            console.log('errorData', errorData);
            return errorData;
        }
    };
    FormValidation.prototype.validateForm = function (Data, formKey, targetElementList) {
        var _this = this;
        var updatedData = Object.assign({}, Data);
        Object.keys(Data).forEach(function (key) {
            if (updatedData[key] && typeof updatedData[key] === 'string') {
                var splitVal = updatedData[key].match('\\{(.*)\\}');
                if (splitVal) {
                    var ciphertext = splitVal[1];
                    var encryptedVal = updatedData[key].replace(splitVal[0], '');
                    var deCrypteddVal = _this.encryptAndDecrypt.enCryptDeCryptValue(encryptedVal, custom_validation_service_1.customValidateFuntionArray.sessionId, false);
                    if (ciphertext && ciphertext === 'cipher' && deCrypteddVal) {
                        updatedData[key] = deCrypteddVal;
                    }
                }
            }
        });
        console.log('Rules List', this.allFormRules[formKey]);
        var result = new validation_1.Validation(this.allFormRules[formKey]).validate(updatedData);
        console.log('errors form submit', result);
        this.clearAllErrorField(formKey);
        if (Object.keys(result).length) {
            var el = targetElementList;
            this.setError(result, formKey, el);
            this.updateFormErrorHtml(result, formKey);
            return false;
        }
        else {
            this.updateFormErrorHtml(result, formKey);
            return true;
        }
    };
    FormValidation.prototype.setError = function (errorData, formkey, element) {
        var _this = this;
        Object.keys(errorData).forEach(function (key) {
            var errorDiveId = element[key].getAttribute('rsValidationError');
            var elements = _this.$form[formkey].querySelectorAll('[rsValidationError="' + errorDiveId + '"]');
            elements.forEach(function (elem) {
                var className = elem.getAttribute('rsInvalidClass');
                if (className) {
                    elem.classList.add(className);
                }
            });
            if (errorDiveId) {
                var errorDiv = _this.$form[formkey].querySelector('[id="' + errorDiveId + '"]');
                if (errorDiv) {
                    errorDiv.innerHTML = errorData[key];
                    errorDiv.classList.add('rs-visible');
                }
            }
        });
    };
    FormValidation.prototype.updateFormErrorHtml = function (result, formKey) {
        var elements = document.querySelectorAll('[rsFormError="' + formKey + '"]');
        if (elements && elements.length > 0) {
            if (result && Object.keys(result).length > 0) {
                var html_1 = '<div>';
                Object.keys(result).forEach(function (key) {
                    html_1 += "<p><span>" + key + "</span>: " + result[key] + "</p>";
                });
                html_1 += "</div>";
                elements[0].innerHTML = html_1;
                elements[0].classList.add('rs-visible');
            }
            else {
                elements[0].innerHTML = '';
                elements[0].classList.remove('rs-visible');
            }
        }
    };
    FormValidation.prototype.clearAllErrorField = function (formkey) {
        var _this = this;
        var elements = this.$form[formkey].querySelectorAll('[rsmonitor]');
        var errorDiv = this.$form[formkey].querySelectorAll('[rsValidationError');
        elements.forEach(function (elem) {
            var className = elem.getAttribute('rsInvalidClass');
            if (className) {
                elem.classList.remove(className);
            }
        });
        errorDiv.forEach(function (errDiv) {
            var errorDiveId = errDiv.getAttribute('rsValidationError');
            var container = _this.$form[formkey].querySelector('[id="' + errorDiveId + '"]');
            if (container) {
                container.innerHTML = '';
                container.classList.remove('rs-visible');
            }
        });
    };
    FormValidation.prototype.clearErrorField = function (elm, formkey) {
        var name = elm.getAttribute('rsValidationError');
        var className = elm.getAttribute('rsInvalidClass');
        var elements = this.$form[formkey].querySelectorAll('[rsValidationError="' + name + '"]');
        elements.forEach(function (elem) {
            if (className) {
                elem.classList.remove(className);
            }
        });
        var errorDiveId = elm.getAttribute('rsValidationError');
        var container = this.$form[formkey].querySelector('[id="' + errorDiveId + '"]');
        if (container) {
            container.innerHTML = '';
        }
    };
    return FormValidation;
}());
exports.FormValidation = FormValidation;
//# sourceMappingURL=form_validation.js.map